import { focusedInputDemo } from '../../../demos/inputs.js';

export const demoFunc = () => focusedInputDemo('dropdown');
